import { render, staticRenderFns } from "./icon-dialog.vue?vue&type=template&id=f23e49f0&"
import script from "./icon-dialog.vue?vue&type=script&lang=js&"
export * from "./icon-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports